import script from "./DirectivePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectivePicker.vue?vue&type=script&setup=true&lang=js"

import "./DirectivePicker.vue?vue&type=style&index=0&id=7afcf94f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7afcf94f"]])

export default __exports__